const surfaceBrands = [
  {
    id: 1, title: "Oberflex",
    codeBrand:"OBS",
    titlePart1: "Essence fine stratifiée Oberflex", // for pdf only
    thicknessByDefaut:"18 mm" // for pdf only
  },
  {
     id: 2, title: "Marotte",
     codeBrand:"MAR",
     titlePart1: "Essence fine vernie Marotte", // for pdf only
     thicknessByDefaut:"17 mm" // for pdf only
  },
  {
     id: 3, title: "Pure Paper Color",
     codeBrand:"PPC",
     titlePart1: "Stratifié Pure Paper Color", // for pdf only
     thicknessByDefaut:"18,6 mm" // for pdf only
  },
  {
     id: 4, title: "Pure Paper Métal",
     codeBrand:"PPM",
     titlePart1: "Stratifié Pure Paper Metal", // for pdf only
     thicknessByDefaut:"17,8 mm"   // exception on surfaces.js 17.2 or 18.2 // for pdf only
  }
]

export const surfaceBrandsByIndex = {
  1: "Oberflex",
  2: "Marotte",
  3: "Pure Paper Color",
  4: "Pure Paper Métal"
}

export const surfaceBrandsByIds = surfaceBrands.reduce((acc, brand) => {
  acc[brand.id] = brand
  return acc
}, {})

export default surfaceBrands



// WEBPACK FOOTER //
// ./src/constants/surfaceBrands.js